
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class SetItemsGrid extends Serenity.EntityGrid<SetItemsRow, any> {
        protected getColumnsKey() { return 'Inventory.SetItems'; }
        protected getDialogType() { return SetItemsDialog; }
        protected getIdProperty() { return SetItemsRow.idProperty; }
        protected getInsertPermission() { return SetItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return SetItemsRow.localTextPrefix; }
        protected getService() { return SetItemsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}